import Component from './DeviceWorkShiftMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfDeviceWorkShiftMonitor', Component);
  },
};
